import type { AvailableCourseTrack, Campus, Region } from '@/types';

export const datoCmsIdMap = {
  campuses: {
    ams: '55500935',
    bcn: '55500936',
    ber: '55500937',
    lis: '55500939',
    lon: '55500942',
    mad: '55500943',
    par: '55500946',
    rmt: '55500929',
  } satisfies Record<Campus, string>,
  categories: {
    alumni: '55344281',
    cy: '55344279',
    da: '55344289',
    ux: '55344273',
    wd: '55344284',
  },
  courses: {
    ai: 'DVpMFtaLTimLlHpesXc7zQ',
    cy: '55714809',
    da: '55714803',
    dv: 'DygAuvogQGmFB7pzQhrVUQ',
    mk: 'CmWXYBswQo2xLg8kmK0l2g',
    ml: 'LQ2KEBpMRe-9ZJ0JAJeQUw',
    ux: '55714804',
    wd: '55656632',
  } satisfies Record<AvailableCourseTrack, string>,
  itemTypes: {
    blogArticle: '874093',
    blogButton: '876441',
    linkButtonTarget: '876603',
  },
  regions: {
    de: '55342474',
    es: '55342455',
    fr: '55342469',
    nl: '55342471',
    pt: '55342470',
    uk: '55342472',
    us: '55342433',
    ww: '55344020',
  } satisfies Record<Region, string>,
} as const;
